'use strict'; 

/**
 * Util for performing action on JCR data
 */

/**
 * Process properties to make them simple
 * @param {Object} node 
 */
let processProperties = function(node){
    if(node.properties){
        for(var i in node.properties){
            if(node.properties[i].type == 'String' && node.properties[i].multiple == false){
                node[node.properties[i].name] = node.properties[i].values[0] ? node.properties[i].values[0] : node.properties[i].values;
            }else{
                node[node.properties[i].name] = node.properties[i].values;
            }
        }
        delete node.properties;
    }
    return node;
};

/**
 * Recurssively process nodes
 * @param {Array} nodes 
 */
let processNodes = function(nodes){
    for(var j in nodes){
        nodes[j] = processProperties(nodes[j]);
        if(nodes[j].nodes){
            nodes[j].nodes = processNodes(nodes[j].nodes);
        }
    }
    return nodes;
};

let transform = function(_data){
    if(_data.identifier){
        // Only run when it is valid JCR
        _data = processProperties(_data);
        if(_data.nodes){
            _data.nodes = processNodes(_data.nodes);
        }
    }
    return _data;
};

module.exports = {
    transform: transform,
};


// WEBPACK FOOTER //
// ./src/product/JCRUtil.js